import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

// Atualize o pipe no seu chatbot-bubble.component.ts
@Pipe({
  name: 'chatMarkdown',
  standalone: true
})
export class ChatMarkdownPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value || typeof value !== 'string') return '';

    let html = value;

    // 1. Converter emojis de texto para HTML
    html = this.convertEmojis(html);

    // Aplicar os estilos específicos antes que o Markdown consuma os marcadores.
    html = this.addStyles(html);

    // 3. Converter markdown
    html = this.convertMarkdown(html);

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private convertMarkdown(text: string): string {
    let html = text;

    // Headers (###, ##, #) - MELHORADO
    html = html.replace(/###\s+(.*?)(?=\n|$)/g, '<h3 class="chat-header">$1</h3>');
    html = html.replace(/##\s+(.*?)(?=\n|$)/g, '<h2 class="chat-header">$1</h2>');
    html = html.replace(/#\s+(.*?)(?=\n|$)/g, '<h1 class="chat-header">$1</h1>');

    // Negrito (** ou __)
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/__(.*?)__/g, '<strong>$1</strong>');

    // Itálico (* ou _)
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    html = html.replace(/_(.*?)_/g, '<em>$1</em>');

    // Listas (•, -, *)
    html = this.convertLists(html);

    // Quebras de linha
    html = html.replace(/\n/g, '<br>');

    return html;
  }

  private convertEmojis(text: string): string {
    let html = text;

    // Emojis comuns no contexto de chatbot
    const emojiMap: { [key: string]: string } = {
      '😚': '😚', // kissing face
      '😗': '😗', // kissing
      '📦': '📦', // package
      '📊': '📊', // chart
      '💰': '💰', // money
      '📈': '📈', // chart increasing
      '📉': '📉', // chart decreasing
      '✅': '✅', // check mark
      '❌': '❌', // cross mark
      '⚠️': '⚠️', // warning
      'ℹ️': 'ℹ️', // info
      '🔍': '🔍', // magnifying glass
      '📋': '📋', // clipboard
      '📅': '📅', // calendar
      '👥': '👥', // people
      '💼': '💼', // briefcase
      '🚗': '🚗', // car
      '💸': '💸', // money with wings
      '🎯': '🎯', // target
    };

    // Converter emojis de texto (opcional)
    html = html.replace(/:\)/g, '😊');
    html = html.replace(/:\(/g, '😢');
    html = html.replace(/:\|/g, '😐');

    return html;
  }

  private convertLists(text: string): string {
    // Dividir por linhas
    const lines = text.split('\n');
    let result = '';
    let inList = false;
    let listItems = '';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      // Verifica se é item de lista (começa com -, •, * ou emoji seguido de -)
      if (/^([•\-\*]|😚|😗)\s+(.*)/.test(line)) {
        const match = line.match(/^([•\-\*]|😚|😗)\s+(.*)/);
        if (match) {
          const [_, bullet, content] = match;

          if (!inList) {
            inList = true;
            listItems = '<ul class="chat-list">';
          }

          // Adicionar classe para bullets com emojis
          const bulletClass = this.getBulletClass(bullet);
          listItems += `<li class="${bulletClass}">${content}</li>`;
        }
      } else {
        // Fecha a lista se estava aberta
        if (inList) {
          listItems += '</ul>';
          result += listItems;
          inList = false;
        }
        result += line + '\n';
      }
    }

    // Fecha lista se ainda aberta no final
    if (inList) {
      listItems += '</ul>';
      result += listItems;
    }

    return result;
  }

  private getBulletClass(bullet: string): string {
    switch(bullet) {
      case '😚': return 'emoji-kiss';
      case '😗': return 'emoji-kiss-light';
      case '•': return 'bullet-dot';
      case '*': return 'bullet-star';
      case '-': return 'bullet-dash';
      default: return 'bullet-default';
    }
  }

  private addStyles(html: string): string {
    // Adiciona spans com classes para estilização
    return html
      .replace(/\*\*FROTA\*\*/g, '<span class="chat-category frota">FROTA</span>')
      .replace(/\*\*VAREJO\*\*/g, '<span class="chat-category varejo">VAREJO</span>')
      .replace(/\*\*SPF Básico\*\*/g, '<span class="chat-product basic">SPF Básico</span>')
      .replace(/\*\*SPF Plus\*\*/g, '<span class="chat-product plus">SPF Plus</span>')
      .replace(/\*\*SPF Normal\*\*/g, '<span class="chat-product normal">SPF Normal</span>')
      .replace(/\*\*([^:]+):\*\*/g, '<span class="chat-label">$1:</span>');
  }
}
